import React, { useEffect, createElement } from 'react';
export function GoogleAnalytics() {
  useEffect(() => {
    // Add gtag.js script
    const script1 = document.createElement('script');
    script1.async = true;
    script1.src = 'https://www.googletagmanager.com/gtag/js?id=G-Q4G2LLT5NM';
    document.head.appendChild(script1);
    // Add gtag configuration
    const script2 = document.createElement('script');
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-Q4G2LLT5NM');
    `;
    document.head.appendChild(script2);
    // Cleanup
    return () => {
      document.head.removeChild(script1);
      document.head.removeChild(script2);
    };
  }, []);
  return null;
}